import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { grnApi, grnErr } from '@/services/grnApi';

const TEXT = {
  reopen: { title: 'Reopen GRN', btn: 'Reopen', note: 'The receipts on it can be reversed or corrected again. Finalise the delivery again to make the next revision — Accounts will need to book it again.' },
  cancel: { title: 'Cancel GRN', btn: 'Cancel GRN', note: 'The GRN is voided. Its receipts go back to "To finalise" and can go on a new GRN.' },
};

/** Admin: reopen (edit) or cancel (reverse) a GRN, with a reason. */
export const GrnReasonDialog = ({ ask, onClose, onDone }) => {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { setReason(''); }, [ask]);
  if (!ask) return null;
  const t = TEXT[ask.action];
  const go = async () => {
    setBusy(true);
    try {
      const g = await grnApi[ask.action](ask.grn.grn_id, reason);
      toast.success(`${g.grn_number} ${ask.action === 'reopen' ? 'reopened' : 'cancelled'}`);
      setReason(''); onDone(g);
    } catch (e) { toast.error(grnErr(e, 'Could not update the GRN')); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="grn-reason-dialog">
        <DialogHeader><DialogTitle>{t.title} {ask.grn.grn_number}</DialogTitle><DialogDescription>{t.note}</DialogDescription></DialogHeader>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (required)" data-testid="grn-reason-input" />
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} data-testid="grn-reason-back">Back</Button>
          <Button variant={ask.action === 'cancel' ? 'destructive' : 'default'} disabled={busy || reason.trim().length < 3} onClick={go} data-testid="grn-reason-confirm">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{t.btn}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GrnReasonDialog;
